import {useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomHelpText from '@s-ui/react-atom-help-text'
import FilterBasic, {filterBasicTypes} from '@adv-mt/mt-filter-basic'

import {
  SELECT_POPOVER_POSITIONS,
  SELECT_POPOVERS_CLASS_NAME,
  SELECT_POPOVERS_ITEM_CLASS_NAME,
  WRAPPERS
} from '../../config.js'
import FilterWrapperBasicSelectPopover from '../SelectPopover/index.js'

const FilterWrapperBasicSelectPopovers = ({
  alignment,
  autoclose,
  filters,
  group,
  onChange,
  onReset,
  overlayContentRef,
  position = SELECT_POPOVER_POSITIONS.RIGHT,
  value,
  withFilterSelector,
  withRemoveSelections,
  withSearchBar,
  wrapper = WRAPPERS.NONE
}) => {
  const [firstFilter] = filters

  const allSelectionsIdSet = new Set(filters.map(({allSelectionsId}) => allSelectionsId))

  const filterNamesWithValue = new Set(
    Object.entries(value || {})
      .filter(([_, [firstSelection]]) => !allSelectionsIdSet.has(firstSelection))
      .map(([key]) => key)
  )

  const [filtersSelected] = filters.filter(({name}) => filterNamesWithValue.has(name))

  const [filterSelector, setFilterSelector] = useState(filtersSelected?.name || firstFilter.name)

  const baseClasses = cx(SELECT_POPOVERS_CLASS_NAME, alignment && `${SELECT_POPOVERS_CLASS_NAME}--${alignment}`)

  const handleChangeFilterSelector = ([currentFilterSelector]) => {
    currentFilterSelector !== filterSelector && setFilterSelector(currentFilterSelector)
  }

  return (
    <div className={baseClasses}>
      {withFilterSelector && (
        <FilterBasic
          onChange={handleChangeFilterSelector}
          options={filters.map(({name, label}) => ({id: name, label}))}
          type={filterBasicTypes.BUTTON_GROUP_SINGLE_SELECTION}
          value={filterSelector}
        />
      )}
      {filters.map(
        ({description, helpText, label, name, nodeLabel, placeholder, showLabel, ...rest}, index) =>
          (!withFilterSelector || (withFilterSelector && filterSelector === name)) && (
            <div className={SELECT_POPOVERS_ITEM_CLASS_NAME} key={`${group}-${name}`}>
              <FilterWrapperBasicSelectPopover
                autoclose={autoclose}
                description={description}
                filters={[{name, placeholder, ...rest}]}
                group={group}
                id={`${group}-${name}`}
                label={label}
                nodeLabel={nodeLabel}
                onChange={onChange}
                onReset={onReset}
                overlayContentRef={overlayContentRef}
                placeholder={placeholder}
                position={position}
                showLabel={showLabel}
                value={{[name]: value[name]}}
                withSearchBar={withSearchBar}
                withRemoveSelections={withRemoveSelections}
                wrapper={wrapper}
              />
              {helpText && <AtomHelpText text={helpText} />}
            </div>
          )
      )}
    </div>
  )
}

FilterWrapperBasicSelectPopovers.displayName = 'FilterWrapperBasicSelectPopovers'
FilterWrapperBasicSelectPopovers.propTypes = {
  alignment: PropTypes.string,
  autoclose: PropTypes.bool,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      allSelectionsId: PropTypes.string,
      allSelectionsLabel: PropTypes.string,
      helpText: PropTypes.string,
      label: PropTypes.string,
      name: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          extendedInfo: PropTypes.string,
          icon: PropTypes.node,
          id: PropTypes.string,
          isHighlighted: PropTypes.bool,
          label: PropTypes.string,
          nestedItems: PropTypes.arrayOf(
            PropTypes.shape({
              extendedInfo: PropTypes.string,
              icon: PropTypes.node,
              id: PropTypes.string,
              isHighlighted: PropTypes.bool,
              label: PropTypes.string
            })
          )
        })
      ),
      placeholder: PropTypes.string
    })
  ),
  group: PropTypes.string,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  overlayContentRef: PropTypes.node,
  position: PropTypes.string,
  value: PropTypes.object,
  withFilterSelector: PropTypes.bool,
  withRemoveSelections: PropTypes.bool,
  withSearchBar: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FilterWrapperBasicSelectPopovers
